// extracted by css-extract-rspack-plugin
export default {"logo":"_4334249f","logoContainer":"_4331d7b8","saveAndContinueButton":"_89552009","languageDiscrepancyDescription":"_8102e62f","toastHeader":"_4b0a88d6"};